import MainPage from "@/user/pages/MainPage";
import AllUsersPage from "@/user/pages/AllUsersPage";
import UserPage from "@/user/pages/UserPage";
import LoginHistoryPage from "@/user/pages/LoginHistoryPage";

const routes = [
  {
    path: "/",
    component: MainPage,
  },
  {
    path: "/users",
    name: "all_users",
    component: AllUsersPage,
  },
  {
    path: "/users/:id",
    name: "user_form",
    component: UserPage,
  },
  {
    path: "/login_history",
    name: "login_history",
    component: LoginHistoryPage,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/user/routes.js